module.exports = __webpack_public_path__ + "static/assets/4f5d819dc899959dd8a5b4ecca56cec2.svg";